<template>
  <tbody class="air-table-t-body">
    <template v-if="!items.length && !loading">
      <tr class="no-data">
        <td :colspan="headers.length">
          <slot name="no-data">
            <div class="no-data-message">
              <span class="empty-state-text">
                {{ $t("no_data") }}
              </span>
            </div>
          </slot>
        </td>
      </tr>
    </template>
    <template v-else v-for="(item, index) in items" class="tr-template">
      <!-- Row loop-->
      <template v-if="!item.new && !item.deleted">
        <tr :key="`td-${index}`" class="t-body-row" :class="[expand === index && 'expanded-row', `rt-${index}`]">
          <!-- actions column -->
          <td class="col-action-td --start" v-if="!hideDots" style="width: 10px">
            <span class="row-dot"></span>
            <!-- New row btn-->
            <Icon
              @click.native="(e) => handleCreateNewRow(e, index)"
              v-if="showCreate"
              class="pseudo-element --default-row-action"
              :path="require('@/assets/table/new-row-plus.svg')"
            />
          </td>

          <!-- data columns -->
          <!-- Item slot by header name -->
          <!-- <template v-slot:item-{head.value}="props" /> -->
          <td
            v-for="(head, tdIndex) in headers"
            v-if="!head.edge"
            :key="`td-${tdIndex}-${index}`"
            :class="[`item-${head.value}`, ...head.class]"
            :style="(width = getWidth(head.width))"
            :align="head.align"
          >
            <slot
              :name="`item-${head.value}`"
              :item="item"
              :head="head"
              :index="tdIndex"
              :itemIndex="index"
              :value="items[index][head.value]"
              :toggleExpand="() => handleExpandedSetup(index)"
              :expandClasses="['expand-btn', expand ? 'expanded' : 'no-expanded']"
              >{{ items[index][head.value] }}
            </slot>
          </td>

          <!-- actions column -->
          <td class="col-action-td --end" style="width: 10px" v-if="!hideDots">
            <span class="row-dot"></span>
          </td>
        </tr>
      </template>

      <!-- Added new rows slot -->
      <template v-else-if="item.new && !item.deleted">
        <tr
          class="t-body-row new-row"
          :key="`td-${index}`"
          :itemIndex="index"
          :class="[expand === index && 'expanded-row', `rt-${index}`]"
        >
          <template>
            <slot name="newRecord" :item="item" :header="headers" :index="index" :undoCreate="handleUndoCreateNewRow">
              <td class="col-action-td --start" style="width: 10px">
                <!-- Save row btn-->
                <Icon
                  :path="require('@/assets/table/save.svg')"
                  @click="handleOnSaveNewRow"
                  class="pseudo-element save-new-record-btn --new-row-actions"
                />

                <!-- Remove row btn-->
                <Icon
                  :path="require('@/assets/table/remove.svg')"
                  class="pseudo-element cancel-new-record-btn --new-row-actions"
                  @click="handleUndoCreateNewRow"
                />
              </td>
              {{ item.value }}
            </slot>
          </template>

          <!-- actions column -->
          <td class="col-action-td --end" style="width: 10px" />
        </tr>
      </template>

      <!-- Expand row slot -->
      <tr v-if="expand === index" class="expand-row" :key="`expand-key-${expandKey}`">
        <td :colspan="headers.length + 1" class="expanded-td">
          <div class="expand-box">
            <slot name="expand" :item="item" :headers="headers" :isExpanded="expand === index" />
          </div>
        </td>
      </tr>
    </template>
  </tbody>
</template>

<script>
import Vue from "vue";

const TBody = Vue.extend({
  name: "TBody",

  data() {
    return {
      expand: -1,
      expandKey: 1,
    };
  },

  props: {
    items: {
      default() {
        return [];
      },
    },
    headers: {
      default() {
        return [];
      },
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    showCreate: {
      type: Boolean,
      default: false,
    },

    handleOnCreateNew: {
      type: Function,
      default: null,
    },

    hideDots: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
    },

    expandFirst: {
      default: false,
      type: Boolean,
    },
  },

  mounted() {
    this.handleExpandFirstItem();
  },

  methods: {
    /**
     * Handle expand first item
     * @return {void}
     */
    handleExpandFirstItem() {
      if (this.expandFirst && this.expand === -1) {
        this.expand = 0;
        this.$forceUpdate();
      }
    },

    /***
     * Handle the expandable functionality
     * @return {void | *}
     */
    handleExpandedSetup(index = null) {
      if (this.expand !== index) {
        this.expand = index;
      } else {
        this.expand = null;
      }

      this.expandKey++;
    },

    /**
     * handle the create new row
     * @return {void | *}
     */
    handleCreateNewRow(e, index) {
      if (typeof this.handleOnCreateNew !== null) {
        return this.handleOnCreateNew(e, index);
      }

      const cloneHeader = _.clone(this.headers);
      const newItem = {};

      cloneHeader.map((item) => {
        newItem[item.value] = "";
      });

      newItem["new"] = true;
      newItem["editable"] = true;

      this.items.splice(++index, 0, newItem);
    },

    /**
     * handle undo create new row
     * @return {void}
     */
    handleUndoCreateNewRow(index) {
      this.items[index]["deleted"] = true;
      this.$forceUpdate();
    },

    /**
     * handle save new row data
     * TODO completing this function
     */
    handleOnSaveNewRow(e) {
      // do some thing to save
    },

    /**
     * Get column width by heade width
     */
    getWidth(width) {
      return width ? `${width}px` : "10px";
    },
  },
});

export default TBody;
</script>

<style scoped src="./styles.scss" lang="scss" />
